import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NoticeTooltipOnHover from '../../../_utils/notice-tooltip';
import PhotoLowResolutionIcon from './photo-low-resolution-icon';
import { POOR_RESOLUTION_MESSAGE } from './constants';

// Displays a full-width "Poor resolution" banner in photo previews, with a tooltip.
const PhotoPreviewWarning = ({
  recommendedPrintSizeText,
  tooltipPosition,
  tooltipCSSClasses,
}) => {
  const tooltipMessage = `${POOR_RESOLUTION_MESSAGE}${
    recommendedPrintSizeText
      ? ` - recommended: ${recommendedPrintSizeText}`
      : ''
  }`;

  const noticeContent = (
    <div
      className={classNames(
        'dpi-notice d-flex align-items-center justify-content-center text-center dpi-notice-below-minimum',
      )}
      aria-label={tooltipMessage}
      role="status"
      tabIndex="0">
      <PhotoLowResolutionIcon
        className="dpi-notice-below-minimum"
        aria-label={tooltipMessage}
      />
      <span aria-hidden="true">Poor resolution</span>
    </div>
  );

  return (
    <NoticeTooltipOnHover
      tooltipCSSClasses={classNames(
        'dpi-tooltip',
        'dpi-tooltip-below-minimum',
        tooltipCSSClasses,
      )}
      tooltipPosition={tooltipPosition}
      content={tooltipMessage}
      show={false}>
      {noticeContent}
    </NoticeTooltipOnHover>
  );
};

PhotoPreviewWarning.propTypes = {
  recommendedPrintSizeText: PropTypes.string,
  tooltipPosition: PropTypes.string,
  tooltipCSSClasses: PropTypes.string,
};

PhotoPreviewWarning.defaultProps = {
  recommendedPrintSizeText: '',
  tooltipPosition: undefined,
  tooltipCSSClasses: undefined,
};

export default PhotoPreviewWarning;
